<template>
  <div
    id="anwesenheiten-export-modal"
    class="modal fade"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <modal-close-button @confirmed="closeModal" />
          <h4 class="modal-title">Lernende Statistik AG</h4>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            {{ $t('global.infotextexport') }}
          </div>
          <div class="row">
            <div class="col-lg-12 col-xl-6">
              <div class="form-group">
                <date-picker
                  date-format="dd.mm.yy"
                  :initial="stichtag"
                  @update="(val) => (stichtag = val)"
                  :show-icon="true"
                  :inModal="true"
                />
                <label>Stichtag</label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-danger"
            @click="closeModal"
          >
            {{ $t('global.cancel') }}
          </button>
          <button
            class="btn btn-success"
            @click="getCarboneExport"
            :disabled="!stichtag"
          >
            {{ $t('global.export') }}
          </button>
        </div>
      </div>
    </div>
    <loading-overlay v-show="loading"></loading-overlay>
  </div>
</template>
<script>
  import Api from '@/api/Api'
  import CarboneApi from '@/api/CarboneApi'
  import ModalCloseButton from '@/components/global/ModalCloseButton'
  import DatePicker from '@/components/Datepicker'
  import page from '@/mixins/Page'
  import FileDownload from 'js-file-download'
  import server from '@/server'

  export default {
    name: 'AnwesenheitenExportModal',
    components: {
      ModalCloseButton,
      DatePicker,
    },
    metaInfo() {},
    mixins: [page],
    props: {},
    data() {
      return {
        stichtag: this.stichtag,
        shown: false,
      }
    },
    watch: {},
    mounted: function () {
      this.$bus.$on('openLernendeStatistikModal', () => {
        if (!this.shown) this.openModal()
      })
    },
    methods: {
      getCarboneExport() {
        this.loading = true

        CarboneApi.get(
          `esz-carbone-statistik-l/?stichtag=${encodeURIComponent(
            this.stichtag
          )}`
        )
          .then(({ data }) => {
            const files = Array.isArray(data) ? data : data ? [data] : []
            if (!files.length) throw new Error('empty payload')

            files.forEach(({ url, name, count, size }) => {
              if (!url) throw new Error('missing url in payload')
              this.saveFile(
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                url,
                name || 'Statistik_Lernende',
                '.xlsx'
              )
            })
          })
          .catch((e) => {
            console.error(e)
            this.$notify({
              type: 'warn',
              title: this.$t('global.actionfailed'),
              text: this.$t('global.exportfailed'),
            })
          })
          .finally(() => {
            this.loading = false
            this.closeModal()
          })
      },

      isDisplayableFile(url) {
        const fileExtension = this.getFileExtension(url)
        if (['docx', 'doc'].includes(fileExtension)) {
          return 'isWordFile'
        } else if (['xls', 'xlsx', 'xlsm'].includes(fileExtension)) {
          return 'isExcelFile'
        }
        return 'isDisplayable'
      },
      getFileExtension(url) {
        const parts = url?.split('.')
        return parts[parts.length - 1].toLowerCase()
      },
      async saveFile(contentType, url, fileName, type) {
        if (!contentType || !url) return

        if (!fileName) fileName = 'Report'
        fileName = fileName + type

        const response = await fetch(Api.defaults.defaultURL + url, {
          headers: {
            'Content-Type': contentType,
          },
        })

        let file = await response.blob()
        FileDownload(file, fileName)
      },

      openModal() {
        $('#statistik-lernende-modal').modal({
          backdrop: 'static',
          keyboard: false,
        })

        this.shown = false
      },

      closeModal() {
        $('#statistik-lernende-modal').modal('hide')
      },
    },
  }
</script>

<style></style>
